import { Component } from 'react'
import { connect } from 'react-redux'
import RelatedContent from 'components/RelatedContent'
import { GroupContentHOC, NavigationHOC } from 'hocs'
import { fetchRelated } from './actions'
import { selectFetchingRelated } from './selectors'

class RelatedContentContainer extends Component {
  componentDidMount() {
    const { contentType, contentId, deviceId } = this.props
    this.props.fetchRelated(contentId, contentType, deviceId)
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { contentType, contentId, deviceId } = nextProps
    if (this.props.contentId !== contentId) {
      this.props.fetchRelated(contentId, contentType, deviceId)
    }
  }

  generateProps = () => ({ ...this.props })

  render() {
    return <RelatedContent {...this.generateProps()} />
  }
}

const mapStateToProps = (state) => ({
  isFetching: selectFetchingRelated(state)
})

const mapDispatchToProps = (dispatch) => ({
  fetchRelated: (id, type, deviceId) =>
    dispatch(fetchRelated.request(id, type, deviceId))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  GroupContentHOC(NavigationHOC(RelatedContentContainer), {
    stateName: 'related'
  })
)
